import { render } from "./NoticeDetailPopup.vue?vue&type=template&id=39e42cd6&scoped=true"
import script from "./NoticeDetailPopup.vue?vue&type=script&lang=js"
export * from "./NoticeDetailPopup.vue?vue&type=script&lang=js"

import "./NoticeDetailPopup.vue?vue&type=style&index=0&id=39e42cd6&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e42cd6"]])

export default __exports__